import useLeadStats from "../../../data/useLeadStats"
import apiConfig from "../../../utils/apiConfig";
import DashboardStat from "../../dashboard/DashboardStat"
import DashboardTile from "../../dashboard/DashboardTile"
import DashboardTileMultiple from "../../dashboard/DashboardTileMultiple";


export default function LeadStats() {
  const { leadStats } = useLeadStats("LeadStats");


  if (leadStats.isLoading || !leadStats.data?.data) return null;

  const stats = leadStats.data?.data;

  const tileClass = "min-w-48"

  return (
    <div className="flex gap-4 flex-wrap bg-white shadow rounded p-4">
      <DashboardStat title={stats.awaitingContact?.toString()} desc={"Awaiting Contact"} color={"gray"} className={tileClass} />
      <DashboardStat title={stats.customerToCallBack?.toString()} desc={"Customer To Call Back"} color={"teal"} className={tileClass} />
      <DashboardStat title={stats.scheduled?.toString()} desc={"Scheduled"} color={"blue"} className={tileClass} />
      <DashboardStat title={stats.reschedule?.toString()} desc={"Reschedule"} color={"yellow"} className={tileClass} />
      <DashboardTileMultiple values={[stats.collected?.toString(), stats.collectedToday?.toString()]} labels={["Collected", "Collected Today"]} subLabels={[]} colour="purple" className={tileClass} borderless />
      <DashboardStat title={stats.awaitingPayment?.toString()} desc={"Awaiting Payment"} color={"pink"} className={tileClass} />
      <DashboardStat title={stats.awaitingCod?.toString()} desc={"Awaiting COD"} color={"indigo"} className={tileClass} />
      <DashboardStat title={stats.cancelled?.toString()} desc={"Cancelled"} color={"red"} className={tileClass} />
      <DashboardTileMultiple values={[stats.completed?.toString(), stats.completedToday?.toString()]} labels={["Completed", "Completed Today"]} subLabels={[]} colour="green" className={tileClass} borderless />
    </div>
  )
}